import { windowAttrs } from './dom';
import {
  DESKTOP_FULL_WIDTH_SLIDESHOW_CONTAINER_WIDTH_PX,
  DESKTOP_SLIDESHOW_CONTAINER_WIDTH_PX,
  NON_MOBILE_GRID_WIDTH_PX,
  BREAKPOINT_MEDIUM_PX,
  BREAKPOINT_LARGE_PX
} from '../constants';
import {get} from 'lodash';

const getWidthFromWidthPercentage = (percentage) => {
  switch (percentage) {
    case 'PAGE': return windowAttrs().innerWidth;
    case 'HALF': return NON_MOBILE_GRID_WIDTH_PX / 2;
    case 'THIRD': return NON_MOBILE_GRID_WIDTH_PX / 3;
    default: return NON_MOBILE_GRID_WIDTH_PX;
  }
};

export default ({
  isFullWidthSlideSection,
  isDesktopSlideSection,
  polyptychAttributes,
  content
}) => {
  if (isFullWidthSlideSection) {
    return DESKTOP_FULL_WIDTH_SLIDESHOW_CONTAINER_WIDTH_PX;
  }

  if (isDesktopSlideSection) {
    return DESKTOP_SLIDESHOW_CONTAINER_WIDTH_PX;
  }

  // A product carousel under a polyptych always takes up the whole grid.
  if (get(polyptychAttributes, 'isLastInPolyptych')) {
    return NON_MOBILE_GRID_WIDTH_PX;
  }

  if (content.width_percentage) {
    return getWidthFromWidthPercentage(content.width_percentage);
  }

  // Only image sections have this.
  const original_width_px = get(content, 'dimensions.original_width_px');

  // Tablet width should always be the non-mobile grid width
  const isTabletWidth =
    windowAttrs().innerWidth <= BREAKPOINT_LARGE_PX && windowAttrs().innerWidth >= BREAKPOINT_MEDIUM_PX;

  const min_width = isTabletWidth
    ? NON_MOBILE_GRID_WIDTH_PX
    : Math.min(NON_MOBILE_GRID_WIDTH_PX, original_width_px);

  return original_width_px
    ? min_width
    : NON_MOBILE_GRID_WIDTH_PX;
};
